import { useOutletContext } from "react-router";

import { ClientNoteView } from "@shared";

import { ClientDetailResponse } from "@/api";
import { ClientStatusWidget } from "@/pages/clients/client/components/client-status-widget/ClientStatusWidget";
import { useTranslation } from "@/translations";

export function ClientNoteTab() {
  const { t } = useTranslation();
  const client = useOutletContext<ClientDetailResponse>();

  return (
    <ClientNoteView
      clientId={client.clientId}
      cardTitle={t("clients.client.clientNote.cardTitle")}
      noticeText={t("clients.client.clientNote.noticeText")}
      navigation={<></>}
      navigationFooter={<ClientStatusWidget client={client} />}
    />
  );
}
